/* ====================================================================
   SH PDP Video Lightbox — V1 (2026-05-24)
   ====================================================================
   Click any .sh-redesign-pdp__slide-video → opens fullscreen modal
   with autoplay + center play/pause toggle. Close = pause + release
   video sources (no bandwidth waste).

   Markup: snippets/sh-pdp-vlb.liquid (rendered once at PDP bottom)
   Styles: assets/sh-pdp-vlb.css
   ==================================================================== */
(function () {
  'use strict';
  if (window.__shPdpVlb) return;
  window.__shPdpVlb = true;

  function init() {
    var lightbox = document.querySelector('[data-pdp-vlb]');
    if (!lightbox) return;
    var video    = lightbox.querySelector('[data-pdp-vlb-video]');
    var toggleEl = lightbox.querySelector('[data-pdp-vlb-toggle]');
    var closeEl  = lightbox.querySelector('[data-pdp-vlb-close]');
    var stageEl  = lightbox.querySelector('[data-pdp-vlb-stage]');
    if (!video || !toggleEl || !closeEl) return;

    function cloneSourcesFrom(srcVideoEl) {
      video.innerHTML = '';
      var sources = srcVideoEl.querySelectorAll('source');
      if (sources.length > 0) {
        Array.prototype.forEach.call(sources, function (s) {
          var clone = document.createElement('source');
          clone.src = s.src;
          if (s.type) clone.type = s.type;
          video.appendChild(clone);
        });
      } else if (srcVideoEl.currentSrc || srcVideoEl.src) {
        var s = document.createElement('source');
        s.src = srcVideoEl.currentSrc || srcVideoEl.src;
        video.appendChild(s);
      }
      if (srcVideoEl.poster) video.poster = srcVideoEl.poster;
    }

    function open(srcVideoEl) {
      cloneSourcesFrom(srcVideoEl);
      try { video.load(); } catch (e) {}
      /* Defensive: remove HTML `hidden` attr in case snippet still has it from an older deploy */
      lightbox.removeAttribute('hidden');
      lightbox.setAttribute('data-open', '');
      document.body.classList.add('sh-vlb-open');
      /* Pre-fit using poster image aspect (loads faster than video metadata)
         so the video element jumps to its target size IMMEDIATELY on open,
         instead of starting tiny at intrinsic size and growing later. */
      if (srcVideoEl.poster) {
        var img = new Image();
        img.onload = function () {
          if (video.videoWidth) return; /* real metadata won already */
          if (!img.naturalWidth || !img.naturalHeight) return;
          var aspect = img.naturalWidth / img.naturalHeight;
          var maxH = window.innerHeight * 0.85;
          var maxW = Math.min(window.innerWidth * 0.95, 1200);
          var h = maxH;
          var w = h * aspect;
          if (w > maxW) { w = maxW; h = w / aspect; }
          video.style.width  = Math.round(w) + 'px';
          video.style.height = Math.round(h) + 'px';
        };
        img.src = srcVideoEl.poster;
      }
      /* Pause the inline source video so audio doesn't double-up */
      try { srcVideoEl.pause(); } catch (e) {}
      /* Try autoplay (muted first for browser compatibility) */
      video.muted = true;
      var p = video.play();
      if (p && p.then) {
        p.then(function () {
          /* Unmute shortly after a successful play so the user gets sound */
          setTimeout(function () { try { video.muted = false; } catch (e) {} }, 80);
        }).catch(function () {
          /* Autoplay blocked — keep the center button visible so the user can press it */
        });
      }
    }

    function close() {
      try { video.pause(); } catch (e) {}
      try { video.currentTime = 0; } catch (e) {}
      /* Release video resources so it stops downloading bytes */
      video.removeAttribute('src');
      video.innerHTML = '';
      try { video.load(); } catch (e) {}
      /* Clear computed size so next open re-fits to fresh metadata */
      video.style.width  = '';
      video.style.height = '';
      lightbox.removeAttribute('data-open');
      lightbox.removeAttribute('data-playing');
      document.body.classList.remove('sh-vlb-open');
    }

    function toggle() {
      if (video.paused || video.ended) {
        var p = video.play();
        if (p && p.catch) p.catch(function () {});
      } else {
        video.pause();
      }
    }

    /* Sync data-playing flag from real video events (handles native controls too) */
    video.addEventListener('play',  function () { lightbox.setAttribute('data-playing', ''); });
    video.addEventListener('pause', function () { lightbox.removeAttribute('data-playing'); });
    video.addEventListener('ended', function () { lightbox.removeAttribute('data-playing'); });

    /* Auto-size video to maximize viewport usage while preserving aspect.
       Browser default = intrinsic size (small for low-res videos). We compute
       the largest box that fits in ~85vh × min(95vw, 1200px) preserving aspect,
       so portrait videos fill vertical, landscape fills horizontal. Runs after
       metadata loads (when videoWidth/Height are known) and on window resize. */
    function fitVideo() {
      if (!video.videoWidth || !video.videoHeight) return;
      var aspect = video.videoWidth / video.videoHeight;
      var maxH = window.innerHeight * 0.85;
      var maxW = Math.min(window.innerWidth * 0.95, 1200);
      var h = maxH;
      var w = h * aspect;
      if (w > maxW) { w = maxW; h = w / aspect; }
      video.style.width  = Math.round(w) + 'px';
      video.style.height = Math.round(h) + 'px';
    }
    video.addEventListener('loadedmetadata', fitVideo);
    video.addEventListener('loadeddata',     fitVideo);
    window.addEventListener('resize', function () { if (lightbox.hasAttribute('data-open')) fitVideo(); });

    /* Button + interaction wiring */
    toggleEl.addEventListener('click', function (e) { e.stopPropagation(); toggle(); });
    closeEl.addEventListener('click',  function (e) { e.stopPropagation(); close(); });

    /* Click on stage (but not on video / toggle / close) = toggle play state.
       Click on backdrop (outside stage) = close. */
    stageEl && stageEl.addEventListener('click', function (e) {
      if (e.target === stageEl || e.target === video) {
        e.stopPropagation();
        toggle();
      }
    });
    lightbox.addEventListener('click', function (e) {
      if (e.target === lightbox) close();
    });

    /* ESC to close (only when open) */
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      if (lightbox.hasAttribute('data-open')) close();
    });

    /* Hook into ALL hero slide videos — click to open lightbox */
    function hookHeroVideos(root) {
      var scope = root && root.querySelectorAll ? root : document;
      scope.querySelectorAll('.sh-redesign-pdp__slide-video').forEach(function (vid) {
        if (vid.__shVlbHooked) return;
        vid.__shVlbHooked = true;
        vid.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          open(vid);
        });
        /* Add an explicit role so screen readers know it's interactive */
        vid.setAttribute('role', 'button');
        vid.setAttribute('tabindex', '0');
        vid.setAttribute('aria-label', 'เปิดวิดีโอแบบเต็มจอ');
        /* Keyboard support — Enter or Space opens lightbox */
        vid.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            open(vid);
          }
        });
      });

      /* 2026-05-24 (Boss): video thumbnails also open the lightbox directly.
         Match thumb's data-media-id to the corresponding slide's video element
         (which already has properly-ordered MP4-first sources). Existing thumb
         click handler still runs to switch main slide — we just ADD the popup. */
      scope.querySelectorAll('.sh-redesign-pdp__thumb--video').forEach(function (thumb) {
        if (thumb.__shVlbThumbHooked) return;
        thumb.__shVlbThumbHooked = true;
        thumb.addEventListener('click', function () {
          var mediaId = thumb.getAttribute('data-media-id');
          var slide = mediaId
            ? document.querySelector('.sh-redesign-pdp__slide[data-media-id="' + mediaId + '"]')
            : null;
          var vid = slide ? slide.querySelector('.sh-redesign-pdp__slide-video') : null;
          /* Fallback: any video element on the page */
          if (!vid) vid = document.querySelector('.sh-redesign-pdp__slide-video');
          if (vid) open(vid);
        });
      });
    }

    hookHeroVideos(document);

    /* Catch videos added later (e.g., section re-render, AJAX) */
    if ('MutationObserver' in window) {
      var mo = new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) {
          var nodes = muts[i].addedNodes;
          if (!nodes) continue;
          for (var j = 0; j < nodes.length; j++) {
            if (nodes[j].nodeType === 1) hookHeroVideos(nodes[j]);
          }
        }
      });
      mo.observe(document.body, { childList: true, subtree: true });
    }

    /* Expose a programmatic open hook for other features (e.g. "watch video" CTA) */
    window.shPdpVlbOpen  = function (vidEl) { if (vidEl) open(vidEl); };
    window.shPdpVlbClose = close;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
